import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"
import { InfoOutlined } from "@mui/icons-material"
import { map } from "lodash"
import "./styles.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

const CellTooltip = ({ contents, color }) => {
  const styles = color ? { color } : undefined
  if (Array.isArray(contents)) {
    contents = map(contents, (content, index) => {
      return (<div>
        {index > 0 && <div className="break" />}
        <div key={`${index}-${content[0]}`}>{content}</div>
      </div>
      )
    })
  }

  return <OPTooltip
    enterDelay={TOOLTIP_ENTER_DELAY_MS}
    title={contents}
    placement="bottom-start"
  >
    <InfoOutlined
      style={styles}
      fontSize="small"
      className="cell-tooltip-info"
    />
  </OPTooltip>
}

CellTooltip.propTypes = {
  contents: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.object,
  ]).isRequired,
  color: PropTypes.string,
}

export default CellTooltip
